"use client";

// import { RewardsBar } from "@/components/rewards/RewardsBar";
import { usePathname } from "next/navigation";
import { useCallback, useEffect } from "react";

import AffiliateTracker from "@/AffiliateTracker";
import { ShopifyAnalyticsScript } from "@/components/ShopifyAnalyticsScript";
import { CartDrawer } from "@/components/cart/cart-drawer";
import AnnouncementBar from "@/components/layout/announcement-bar";
import Footer from "@/components/layout/footer";
import Header from "@/components/layout/header";
import { I18nProvider } from "@/components/providers/i18n-provider";
import CallIcon from "@/components/shared/CallIcon";
import TelegramButton from "@/components/shared/TelegramButton";
import WhatappButton from "@/components/shared/WhatappButton";
import { TrackingInitializer } from "@/components/tracking-initializer";
import { AuthProvider } from "@/contexts/auth-context";
import { CartProvider } from "@/contexts/cart-context";
import { EventType, type IPageViewEvent, publishEvent } from "@/events";
import KwikPass from "@/shopify/KwikPass";

export default function ClientBody({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const sendPageView = useCallback((url: string) => {
    const event: IPageViewEvent = {
      type: EventType.PAGE_VIEW,
      path: url,
      title: document.title,
      timestamp: Date.now(),
    };

    if (typeof window !== "undefined") {
      if (typeof window.fbq === "function") {
        window.fbq("track", "PageView");
      }

      // Fire GA
      if (typeof window.gtag === "function") {
        window.gtag("event", "page_view", {
          page_path: url,
          page_title: document.title,
        });
      }

      publishEvent(event);
    }
  }, []);

  // Remove any extension-added classes during hydration
  useEffect(() => {
    // This runs only on the client after hydration
    document.body.className = "antialiased";
  }, []);

  useEffect(() => {
    setTimeout(() => {
      // HACK: Delay to ensure the page is fully loaded after that will fire the script
      sendPageView(pathname);
    }, 2000);
  }, [pathname, sendPageView]);

  return (
    <I18nProvider>
      <AuthProvider>
        <CartProvider>
          <div className="antialiased">
            <AnnouncementBar />
            <Header />
            {children}
            <AffiliateTracker />
            <TrackingInitializer />
            <ShopifyAnalyticsScript />
            <KwikPass />
            <CartDrawer />
            {/* <RewardsBar /> */}
            {/* <WhatappButton /> */}
            {/* <TelegramButton /> */}
            {/* <CallIcon /> */}

            <Footer />
          </div>
        </CartProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
